import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
//Services
import { RouterService } from 'src/app/services/router/router.service';
import { AuthGnxService } from 'src/app/services/authGnx/auth-gnx.service';
import { LanguagesService } from '../../../services/languagesService/languages.service';
import { ValidateVersionService } from '../../../services/validateVersion/validate-version.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { TagsService } from 'src/app/services/tags/tags.service';
import { CaptchaService } from 'src/app/services/captcha/captcha.service';
import { AuthService } from 'src/app/services/auth/auth.service';
//Interfaces
import { IAuthError, IInputError, IPageLogin } from 'src/app/interfaces/ILangs';
import { ICheckUserAnswer } from 'src/app/interfaces/IAuth';
//Component
import { ContactModalComponent } from 'src/app/components/contact-modal/contact-modal.component';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserService } from 'src/app/services/user/user.service';
import { TYPES_REGISTER } from '../register/register.page';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
export const LOADER_ID_LOGIN = 'login';

@Component({
  selector: 'app-login',
  templateUrl: 'login.page.html',
  styleUrls: ['login.page.scss'],
})
export class LoginPage implements OnInit {
  loginForm: FormGroup;
  LOADER_ID = LOADER_ID_LOGIN;
  registerMethods: any = {};
  msgUnverfiedEmail: string;
  authMethods: any = {};
  captcha: string;
  siteKey: string;
  error;
  register_type;
  //texts IU for language
  textsIUPageLogin: IPageLogin;
  textsIUAuthError: IAuthError;
  textsIUInputError: IInputError;
  subscribeBuild$ = new Subject<void>();
  resUserTypes:any


  phoneIndicators;
  constructor(
    private formBuilder: FormBuilder,
    private authGnx: AuthGnxService,
    private routerService: RouterService,
    public languageService: LanguagesService,
    private validateVersion: ValidateVersionService,
    private alertService: AlertService,
    public remoteConfig: RemoteConfigService,
    private tagsService: TagsService,
    private modalController: ModalController,
    private authService: AuthService,
    private captchaService: CaptchaService,
    private loaderService: LoaderService,
    private storage: StorageService,
    private userService: UserService,
    private utilsService: UtilsService


  ) {
    this.initConstructor();
  }

  private initConstructor() {
    this.loginForm = this.formBuilder.group({
      document: [
        '',
        Validators.compose([Validators.required, Validators.minLength(3)]),
      ],
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~]).{8,}$"
          ),
        ]),
      ],
    });
  }

  ionViewDidEnter() {
    this.getUserTypes();
    this.getIndicators();

  }

  get f() {
    return this.loginForm.controls;
  }

  async getUserTypes() {
    this.utilsService.getUserTypes()
      .pipe(takeUntil(this.subscribeBuild$))
      .subscribe({
        next: (val: any) => {
          this.resUserTypes = val;
          console.log("___getUserTypes", this.resUserTypes);
          this.getUserType();
        },
        error: (err: any) => {
          console.error("Error fetching build version:", err);
        }
      });
  }

  async ngOnInit() {
    await this.storage.removeAll();
    this.validateVersion.validate();
    this.tagsService.setEventTag(
      'login_page',
      'login_screen_viewed',
      true,
      true
    );
  }

  getUserType() {
    // const body = {
    //   app_id: environment.gluky.app_id,
    // };
    // this.authService.getRegisterConfigData(body).subscribe((res: any) => {


      this.register_type = this.resUserTypes[0]?.register_type ?? TYPES_REGISTER.iddoc;
      // this.register_type =  TYPES_REGISTER.username;
      if (this.resUserTypes) {
        const validatorsPhone = {
          phone: [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(10),
            Validators.pattern('^[0-9]*$'),
          ],
          email: [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              "^[a-zA-Z0-9#$%&'*/=?^_+-`{|}~]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
            ),
            Validators.email,
          ],
          username: [Validators.required, Validators.minLength(4)],
        };
        if (this.register_type != TYPES_REGISTER.iddoc) {
          this.loginForm.controls['document'].setValidators(
            validatorsPhone[this.register_type]
          );
          if (this.register_type == TYPES_REGISTER.phone) {
            this.loginForm.addControl(
              'indicator',
              this.formBuilder.control(
                this.phoneIndicators[0],
                Validators.required
              )
            );
            this.loginForm.updateValueAndValidity();
          }
        }
      }
    // });
  }

  async getIndicators() {
    var indicatorStorage = await this.storage.get('phoneIndicators');
    if (indicatorStorage && indicatorStorage.length > 0) {
      this.phoneIndicators = indicatorStorage;
    } else {
      this.remoteConfig.getInfoApp().subscribe((data: any) => {
        if (data['phone-indicators']) {
          this.phoneIndicators = data['phone-indicators'];
          this.storage.set('phoneIndicators', this.phoneIndicators);
        }
      });
    }
  }

  redirectToRegister() {
    this.authGnx.redirectToRegister();
  }
  redirectToForgot() {
    this.routerService.redirect('forgot');
  }

  async changeLanguage(language: string) {
    this.languageService.loadLanguage(language);
  }

  get getTextsPageLogin() {
    return this.languageService.textsIU.page_login;
  }
  get getInputError() {
    return this.languageService.textsIU.input_error;
  }

  async contactForm() {
    const modal = await this.modalController.create({
      component: ContactModalComponent,
      cssClass: 'my-custom-class gnx-modal',
    });

    modal.onDidDismiss().then((contact) => {
      console.log('values login', contact);
      if (contact.data.dataU != undefined) {
        this.alertService.presentAlert(`tus datos fueron enviados`);
      }
    });

    return await modal.present();
  }

  seePassword(input, icon) {
    input.type = input.type == 'text' ? 'password' : 'text';
    icon.name = icon.name == 'eye-outline' ? 'eye-off-outline' : 'eye-outline';
  }

  async getCaptcha() {
    this.error = '';
    if (!this.loginForm.valid) {
      this.alertService.presentAlert('Completa todos los campos correctamente');
      return;
    }
    this.loaderService.presentLoading(this.LOADER_ID);
    const containerCaptcha = document.getElementById('recaptcha-login');
    const id = Math.round(Math.random());
    containerCaptcha.innerHTML = `<div id='recaptcha-login${id}'></div>`;
    window['grecaptcha'].render(`recaptcha-login${id}`, {
      sitekey: this.captchaService.siteKey,
      size: 'invisible',
    });
    window['grecaptcha']
      .execute()
      .then((token) => {
        this.checkDocument(token);
        this.loaderService.cancelLoader(this.LOADER_ID);
        document.getElementById(`recaptcha-login${id}`).remove();
      })
      .catch((err) => {
        this.loaderService.cancelLoader(this.LOADER_ID);
        console.error('getCaptcha execute().catch err', err);
        // this.alertService.presentAlert('Error al obtener el captcha');
        // document.getElementById(`recaptcha-login${id}`).remove();
        this.error = 'Error al obtener el captcha Intenta de nuevo';
      });
  }

  checkDocument(token) {
    this.loaderService.presentLoading(this.LOADER_ID);
    this.error = '';
    const body = {
      app_id: environment.gluky.app_id,
      iddoc: this.f.document.value,
      captcha: token,
    };

    if (this.register_type != 'iddoc') {
      body[this.register_type] =
        this.register_type == 'phone'
          ? this.f.indicator.value.indicator + this.f.document.value
          : this.f.document.value;
      delete body['iddoc'];
    }

    this.authService.checkIfRegistered(body).subscribe(
      (res: ICheckUserAnswer) => {
        if (res.registered) {
          try {
            const password = this.f.password.value;
            const email = res.email;
            this.authGnx
              .loginWithUserAndPassword(
                this.LOADER_ID,
                email,
                password,
                this.captcha
              )
              .then(async (res) => {
                console.log('loginWithUserAndPassword res ', res);
                try {
                  console.log('loginWithUserAndPassword then start try');

                  await this.userService.checkIfProfileComplete();
                  this.loginForm.reset();
                  this.loaderService.cancelLoader(this.LOADER_ID);
                  console.log('loginWithUserAndPassword then end try');
                } catch (error) {
                  this.loaderService.cancelLoader(this.LOADER_ID);
                  console.error('checkIfProfileComplete catch err', error);
                }
              })
              .catch((err) => {
                this.loaderService.cancelLoader(this.LOADER_ID);
                console.log(
                  'this.authService.checkIfRegistered(body). catch err',
                  err
                );
                if (err.message) {
                  if (err.message.includes('timeout')) {
                    return this.alertService.presentAlert(
                      'Comprueba tu conexión a internet'
                    );
                  }
                  if (err.message.includes('regex')) {
                    return this.alertService.presentAlert(
                      'Valida que todos los campos cumplan los requerimientos necesarios'
                    );
                  }
                }
                switch (err.code) {
                  case 'auth/invalid-email':
                    this.error = 'Email invalido';
                    break;
                  case 'auth/user-disabled':
                    this.error = 'Usuario deshabilitado';
                    break;
                  case 'auth/user-not-found':
                    this.error = 'Usuario no encontrado';
                    break;
                  case 'auth/wrong-password':
                    this.error = 'Contraseña incorrecta';
                    break;
                  case 'auth/too-many-requests':
                    this.error =
                      'Demasiados intentos incorrectos. Prueba mas tarde o ingresa a recuperar contraseña';
                    break;
                  case 'USER_MULTIPLE':
                    this.error =
                      'Usuario con multiples cuentas, comunícate con tu asesor';
                    break;
                  default:
                    // this.error = err;
                    this.error = 'Contraseña incorrecta';
                    break;
                }
              });
            this.loginForm.reset();
          } catch (error) {
            this.loaderService.cancelLoader(this.LOADER_ID);
            console.error('checkDocument catch error', error);
          }
        } else {
          this.loaderService.cancelLoader(this.LOADER_ID);
          this.error = 'Usuario no existente';
        }
      },
      (error) => {
        this.error = error.message;
        this.loaderService.cancelLoader(this.LOADER_ID);
        if (error.message.includes('timeout')) {
          this.alertService.presentAlert(' Comprueba tu conexión a internet');
        }
        if (error.message.includes('regex')) {
          return this.alertService.presentAlert(
            'Valida que todos los campos cumplan los requerimientos necesarios'
          );
        }
      }
    );
  }

  get getTextsPageRegister() {
    return this.languageService.textsIU.page_register;
  }
}
